import {
  defineComponent as __defineComponent,
  normalizeClass as _normalizeClass,
  cloneVNode,
  Comment,
  createBlock,
  createElementBlock,
  createElementVNode,
  createVNode,
  Fragment,
  getCurrentInstance,
  isVNode,
  openBlock,
  renderList,
  Text,
  withCtx
} from "vue";
const cacheMap = /* @__PURE__ */ new WeakMap();
export function createVNodeCache(key) {
  const i = getCurrentInstance();
  if (i) {
    if (!cacheMap.has(i)) cacheMap.set(i, {});
    const caches = cacheMap.get(i);
    return caches[key] || (caches[key] = []);
  } else {
    return [];
  }
}
export function normalizeVNode(value, flag = 1) {
  let create = createVNode;
  let isBlock = false;
  if (typeof value === "function") {
    isBlock = true;
    openBlock();
    create = createBlock;
    value = value();
  }
  return isVNode(value) ? isBlock ? createBlock(cloneIfMounted(value)) : cloneIfMounted(value) : Array.isArray(value) ? isBlock ? createElementBlock(
    Fragment,
    null,
    value.map((n) => normalizeVNode(() => n)),
    -2
  ) : createElementVNode(Fragment, null, value.slice()) : value == null || typeof value === "boolean" ? create(Comment) : create(Text, null, String(value), flag);
}
function cloneIfMounted(child) {
  return child.el === null && child.patchFlag !== -1 || // @ts-ignore
  child.memo ? child : cloneVNode(child);
}
const normalizeSlotValue = (value) => Array.isArray(value) ? value.map((n) => normalizeVNode(n)) : [normalizeVNode(value)];
export const normalizeSlot = (rawSlot) => {
  if (rawSlot._n) {
    return rawSlot;
  }
  return withCtx((...args) => {
    return normalizeSlotValue(rawSlot(...args));
  });
};
export const normalizeSlots = (slots) => {
  return typeof slots === "function" || Object.prototype.toString.call(slots) === "[object Object]" && !isVNode(slots) ? slots : {
    default: withCtx(() => [normalizeVNode(() => slots)])
  };
};
export const normalizeClass = (value) => _normalizeClass(value) || null;
export const defineComponent = __defineComponent;
export const For = defineComponent(
  (props, {
    slots
  }) => {
    const defaultSlot = slots.default;
    return () => (openBlock(true), createElementBlock(
      Fragment,
      null,
      renderList(props.in, (item, key, index) => {
        const result = defaultSlot(item, key, index);
        return Array.isArray(result) ? result.length === 1 ? result[0] : normalizeVNode(result) : result;
      }),
      128
    ));
  },
  { props: ["in"] }
);
